import { useEffect, useState } from "react";

const TABLET_BREAKPOINT = 950;
const DESKTOP_BREAKPOINT = 1024;

const getInitialWidth = () => (typeof window === "undefined" ? DESKTOP_BREAKPOINT : window.innerWidth);

/**
 * Minimal viewport helper that exposes responsive buckets.
 *
 * @returns {{width: number, isDesktop: boolean, isTablet: boolean, isMobile: boolean}} Current viewport measurements and flags.
 */
export default function useViewport() {
  const [width, setWidth] = useState(getInitialWidth);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    let frame;
    const handleResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setWidth(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return {
    width,
    isDesktop: width >= DESKTOP_BREAKPOINT,
    isTablet: width >= TABLET_BREAKPOINT && width < DESKTOP_BREAKPOINT,
    isMobile: width < TABLET_BREAKPOINT,
  };
}
